import { render } from "./removeCustomList.vue?vue&type=template&id=455fb9b4"
import script from "./removeCustomList.vue?vue&type=script&lang=js"
export * from "./removeCustomList.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/weektodo/weektodo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__